module.exports = __webpack_public_path__ + "media/images/ceremony/plans/2/estimate_3-678eb114ebda98398a8d76a92faf3f4d.jpg";